/** Abas do detalhe do aluno (spec 006, CA-07); fora do componente pelo mesmo motivo de `cadastros/abas.ts`. */
export const ABAS_DO_ALUNO = ['perfil', 'atendimentos', 'treinos', 'documentos', 'cursos'] as const;
export type AbaDoAluno = (typeof ABAS_DO_ALUNO)[number];
